import { render } from "./EmpleadoExtendidoPanel.vue?vue&type=template&id=d3491936&scoped=true"
import script from "./EmpleadoExtendidoPanel.vue?vue&type=script&lang=js"
export * from "./EmpleadoExtendidoPanel.vue?vue&type=script&lang=js"

import "./EmpleadoExtendidoPanel.vue?vue&type=style&index=0&id=d3491936&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3491936"]])

export default __exports__